import {RegionType} from "@pg-rp/common-types";

import {IVariables} from "../../km_app/state/variables_slice";

export const getAllRegionTypesFromVariable = (_state: {variables: IVariables}) => {
    // TODO: currently API doesn't return region_type in variables, the code below should be changed when API starts returning these values
    // const regionTypes = state.variables?.region_type || [];
    // const allRegionTypeValues = regionTypes.map((rt) => rt.value);
    //
    // return allRegionTypeValues;

    return [
        RegionType.VOIVODESHIP,
        RegionType.AGGREGATION,
        RegionType.COUNTY,
        RegionType.CITY,
        RegionType.TOWN,
        RegionType.DISTRICT,
        RegionType.NEIGHBORHOOD,
        RegionType.SURROUNDINGS
    ];
};
import {RegionType} from "@pg-rp/common-types";

import {IVariables} from "../../km_app/state/variables_slice";

export const getAllRegionTypesFromVariable = (_state: {variables: IVariables}) => {
    // TODO: currently API doesn't return region_type in variables, the code below should be changed when API starts returning these values
    // const regionTypes = state.variables?.region_type || [];
    // const allRegionTypeValues = regionTypes.map((rt) => rt.value);
    //
    // return allRegionTypeValues;

    return [
        RegionType.VOIVODESHIP,
        RegionType.AGGREGATION,
        RegionType.COUNTY,
        RegionType.CITY,
        RegionType.TOWN,
        RegionType.DISTRICT,
        RegionType.NEIGHBORHOOD,
        RegionType.SURROUNDINGS
    ];
};
